export default el=>el?.offsetHeight > 0;